import { ReactNode } from 'react';

import { PermissionEnum } from '../constants/permissions';
import { useHasPermission } from '../hooks/useHasPermission';

type CanProps = {
  I: PermissionEnum | PermissionEnum[];
  children: ReactNode | ((hasPermission: boolean) => ReactNode);
  requireAll?: boolean;
};

export const Can = ({ I: permission, children, requireAll = false }: CanProps) => {
  const hasPermission = useHasPermission(permission, requireAll);

  return (
    <>{typeof children === 'function' ? children(hasPermission) : hasPermission && children}</>
  );
};
